var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"}},[_c('path',{attrs:{"d":"M6.9 4.88L2.31.29A1 1 0 10.9 1.71l4.6 4.58a1 1 0 010 1.42L.9 12.29a1 1 0 001.41 1.42L6.9 9.12a3 3 0 000-4.24z","fill":"#FEFEFE"}})])}
var staticRenderFns = []

export { render, staticRenderFns }